import type { PropsWithChildren } from 'react';

import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';

import Book from '@quick/assets/icons/form/book.svg';

import { useAppTranslation } from '@/app/i18n/client';

import {
  animationClassName,
  focusWithinClassName,
  gapClassName,
  groupClassName,
} from '../classNames';
import { useFormDataContext } from '../FormDataContext';
import type { IForm } from '../types';

import { CommonTitle } from './CommonTitle';

export function OthersTitle({ children }: PropsWithChildren) {
  const { t } = useAppTranslation(['demand', 'common']);
  const { serviceType, modality, data } = useFormDataContext();
  const { watch } = useFormContext<IForm>();

  const requiresWaresDescription = serviceType?.req_merchandise_description;
  const requiresDeclaredValue = modality?.declared_value;
  const showServicesQuantity = modality?.service_quantity;
  const requiresConditions = modality?.transport_conditions;
  const [modalityId, loadType] = watch(['modality_id', 'cargo_type_id']);
  const showCouponAndOrderNo = modalityId && loadType;

  // Prevent showing group if no fields are shown
  if (
    !requiresWaresDescription &&
    !requiresDeclaredValue &&
    !showServicesQuantity &&
    !requiresConditions &&
    !showCouponAndOrderNo
  )
    return null;

  // Prevent showing form parts for operations user
  if (!data?.lines?.length) return null;

  return (
    <div
      className={clsx(
        'flex flex-col',
        groupClassName,
        gapClassName,
        animationClassName,
        focusWithinClassName
      )}
    >
      <CommonTitle title={t('common:other', { count: 2 })} Icon={Book} />
      {children}
    </div>
  );
}
